import {
  base_colorContentBorder,
  base_colorSurfaceSecondary,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import { font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

const inlineConfirmationPanelStyle = css`
  margin-top: ${spacing(2)};
  border: 1px solid ${base_colorContentBorder};
  background: ${base_colorSurfaceSecondary};
  border-radius: ${cornerRadius};
  padding: ${spacing(4)} ${spacing(5)};
  display: flex;
  flex-direction: column;
  ${font_md};
  gap: ${spacing(8)};

  .inline-confirmation-actions {
    display: flex;
    justify-content: flex-end;
    gap: ${spacing(6)};
  }
`

export default inlineConfirmationPanelStyle
